const container = {
    width: "100%",
    maxWidth: "600px",
    height: "50px",
    background: "var(--wa-papel)",
    border: "1px solid var(--wa-acento)",
    padding: "0",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: "5px"
}

const clearFilter = {
    display: "flex",
    width: "20px",
    height: "100%"
}

const clearFilterBtn = {
    color: "var(--wa-apagado)",
    padding: "10px",
    background: "var(--wa-papel)",
    width: "100%",
    height: "44px"
}

const inputContainer = {
    width: "100%",
    paddingLeft: "10px"
}

const inputSearch = {
    background: "var(--wa-papel)",
    width: "100%",
    height: "44px"
}

const searchBtnContainer = {
    display: "flex",
    width: "30px"
}

const searchBtn = {
    color: "var(--wa-apagado)",
    background: "var(--wa-papel)",
    width: "100%",
    height: "44px"
}

export const styles =
{
    container,
    clearFilter,
    clearFilterBtn,
    inputContainer,
    inputSearch,
    searchBtnContainer, 
    searchBtn
}